import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'
import { getDeviceList } from '../../actions'
import LoadingSpinner from '../Global/LoadingSpinner'
import { FillerDiv, CenteredDiv, DivWithMargin } from '../StyledComponents/Fillers'
import { DevicesRow } from '../StyledComponents/Devices/DeviceList'
import TableViewCellTitle from '../Settings/TableViewCellTitle'

import SensorListItem from '../Devices/SensorListItem'
import ValveListItem from '../Devices/ValveListItem'

class DeviceListPage extends Component {
    componentDidMount() {
        this.props.getDeviceList()
    }

    render() {
        const { deviceList } = this.props

        if (!deviceList || isEmpty(deviceList)) {
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        const sensors = deviceList.sensors.map(device => (
            <SensorListItem sensor={device} key={device.uuid} />
        ))

        const valves = deviceList.valves.map(device => (
            <ValveListItem device={device} key={device.uuid} />
        ))

        return (
            <FillerDiv>
                <TableViewCellTitle background="#fff" text="Sensoren" />
                <DevicesRow>{sensors}</DevicesRow>
                <TableViewCellTitle background="#fff" text="Ventile" />
                <DevicesRow>{valves}</DevicesRow>
                <DivWithMargin bottom="20" />
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    deviceList: state.deviceList,
})

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, { getDeviceList })
)(DeviceListPage)



// WEBPACK FOOTER //
// ./src/components/pages/DeviceList.js